import React from 'react';
import NoSelectionCard from './NoSelectionCard ';
import NoDataCard from './NoDataCard';
import ComingSoonCard from './ComingSoonCard ';
import HubsDetailPanel from './HubsDetailPanel';
import SoftwareDetailPanel from './SoftwareDetailPanel';
import PatientSurveyDetailPanel from './PatientSurveyDetailPanel';
import WellnessDetailPanel from './WellnessDetailPanel';
import AdherenceDetailPanel from './AdherenceDetailPanel';
import IssuesDetailPanel from './IssuesDetailPanel';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { getFacilityRoleById } from '../../../shared/utils';
import { UserRoles } from '../../../shared/constants';

interface DetailPanelProps {
  card: string;
  selectedTab: number;
}

const DetailPanel: React.FC<DetailPanelProps> = ({ card, selectedTab }) => {
  const { dashboardUserInfo } = useSelector(
    (state: RootState) => state.dashboardUser,
  );

  const currentRole = dashboardUserInfo?.facility_role_id
    ? getFacilityRoleById(dashboardUserInfo.facility_role_id)
    : null;

  const isFacilityAdmin = currentRole === UserRoles.FACILITY_ADMIN;

  if (!card) {
    return <NoSelectionCard />;
  }

  switch (card) {
    case 'adherence':
      return (
        <AdherenceDetailPanel
          selectedTab={selectedTab}
          isFacilityAdmin={isFacilityAdmin}
        />
      );
    case 'hubs':
      return (
        <HubsDetailPanel
          selectedTab={selectedTab}
          isFacilityAdmin={isFacilityAdmin}
        />
      );
    case 'issues':
      return (
        <IssuesDetailPanel
          selectedTab={selectedTab}
          isFacilityAdmin={isFacilityAdmin}
        />
      );
    case 'survey':
      return (
        <PatientSurveyDetailPanel
          selectedTab={selectedTab}
          isFacilityAdmin={isFacilityAdmin}
        />
      );
    case 'software':
      return (
        <SoftwareDetailPanel
          selectedTab={selectedTab}
          isFacilityAdmin={isFacilityAdmin}
        />
      );
    case 'wellness':
      return (
        <WellnessDetailPanel
          selectedTab={selectedTab}
          isFacilityAdmin={isFacilityAdmin}
        />
      );
    case 'vitals':
      return <ComingSoonCard />;

    default:
      return <NoDataCard />;
  }
};

export default DetailPanel;
